import { StandardDataItem } from '../types'

export const STANDARD_DATA_ITEMS: StandardDataItem[] = [
  {
    number: 1,
    concept: 'Satuan Pendidikan',
    definition:
      'Kelompok layanan pendidikan yang menyelenggarakan pendidikan pada jalur formal, nonformal, dan informal pada setiap jenjang dan jenis pendidikan.',
    classification: '-',
    unit: 'Unit',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 2,
    concept: 'Jalur Pendidikan yang diselenggarakan oleh Satuan Pendidikan',
    definition:
      'Wahana yang dilalui peserta didik untuk mengembangkan potensi diri dalam suatu proses pendidikan yang sesuai dengan tujuan pendidikan.',
    classification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: jalur pendidikan',
    unit: 'Unit',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 3,
    concept: 'Jenjang Pendidikan yang diselenggarakan oleh Satuan Pendidikan',
    definition:
      'Tahapan pendidikan yang ditetapkan berdasarkan tingkat perkembangan peserta didik, tujuan yang akan dicapai, dan kemampuan yang dikembangkan',
    classification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: jalur pendidikan',
    unit: 'Unit',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 4,
    concept: 'Jenis Pendidikan yang diselenggarakan oleh Satuan Pendidikan',
    definition:
      'Kelompok yang didasarkan pada kekhususan tujuan pendidikan suatu satuan pendidikan.',
    classification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: jalur pendidikan',
    unit: 'Unit',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 5,
    concept: 'Jenis Pendidikan yang diselenggarakan oleh Satuan Pendidikan',
    definition:
      'Program pendidikan yang diselenggarakan oleh satuan pendidikan',
    classification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: jalur pendidikan',
    unit: 'Unit',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 6,
    concept: 'Kementerian atau Lembaga Pembina Satuan Pendidikan',
    definition:
      'Kementerian atau kementerian/lembaga lain yang membina satuan pendidikan',
    classification: '-',
    unit: 'Unit',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 7,
    concept:
      'Status Satuan Pendidikan yang diselenggarakan oleh Satuan Pendidikan',
    definition: 'Status penyelenggaraan satuan pendidikan',
    classification:
      'Sesuai dengan kode referensi operasional data induk pendidikan: status satuan pendidikan',
    unit: 'Unit',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 8,
    concept: 'Kelurahan/Desa lokasi Satuan Pendidikan',
    definition:
      'Nama Kelurahan/Desa lokasi Satuan Pendidikan berdasarkan data wilayah yang ditetapkan oleh kementerian yang menyelenggarakan urusan di bidang pemerintahan dalam negeri',
    classification:
      'Kode kelurahan/desa berdasarkan Peraturan Menteri Dalam Negeri tentang Kode, Data Wilayah Administrasi Pemerintahan, dan Pulau',
    unit: 'Satuan lingkungan setempat (SLS)/Desa/Kelurahan, wilayah',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 9,
    concept: 'Kecamatan lokasi Satuan Pendidikan',
    definition:
      'Nama kecamatan sesuai dengan lokasi satuan pendidikan berdasarkan data wilayah yang ditetapkan oleh kementerian yang menyelenggarakan urusan di bidang pemerintahan dalam negeri',
    classification:
      'Kode kecamatan berdasarkan Peraturan Menteri Dalam Negeri tentang Kode, Data Wilayah Administrasi Pemerintahan, dan Pulau',
    unit: 'Satuan lingkungan setempat (SLS)/Desa/Kelurahan, wilayah',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 10,
    concept: 'Kabupaten/Kota lokasi Satuan Pendidikan',
    definition:
      'Nama kabupaten/kota sesuai dengan lokasi Satuan Pendidikan berdasarkan data wilayah yang ditetapkan oleh kementerian yang menyelenggarakan urusan di bidang pemerintahan dalam negeri',
    classification:
      'Kode kabupaten/kota berdasarkan Peraturan Menteri Dalam Negeri tentang Kode, Data Wilayah Administrasi Pemerintahan, dan Pulau',
    unit: 'Satuan lingkungan setempat (SLS)/Desa/Kelurahan, wilayah',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 11,
    concept: 'Provinsi lokasi Satuan Pendidikan',
    definition:
      'Nama provinsi sesuai dengan lokasi Satuan Pendidikan berdasarkan data wilayah yang ditetapkan oleh kementerian yang menyelenggarakan urusan di bidang pemerintahan dalam negeri',
    classification:
      'Kode provinsi berdasarkan Peraturan Menteri Dalam Negeri tentang Kode, Data Wilayah Administrasi Pemerintahan, dan Pulau',
    unit: 'Satuan lingkungan setempat (SLS)/Desa/Kelurahan, wilayah',
    values: ['Jumlah', 'Persentase'],
  },
  {
    number: 12,
    concept: 'Badan Penyelenggara Satuan Pendidikan',
    definition:
      'Penyelenggara dan/atau satuan pendidikan yang didirikan oleh Pemerintah atau masyarakat berbentuk badan hukum pendidikan yang berfungsi memberikan pelayanan pendidikan kepada peserta didik',
    classification: '-',
    unit: 'Unit',
    values: ['Jumlah', 'Persentase'],
  },
]
